import { validationTypes } from 'components/FormCreator/types';
import { DataType } from 'components/BasicTable/types';

export interface Contact {
	id: number;
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	ccId?: string;
	lastLoginDate?: Date;
	oid?: string;
	language?: string;
	role?: string;
	status?: string;
	fullName?: string;
	createdAt?: Date;
	updatedAt?: Date;
	deletedAt?: Date;
}

export const ContactId: keyof Contact = 'id';

export enum ContactSupportFields {
	SUBJECT = 'subject',
	MESSAGE = 'message',
}

export enum SupportType {
	General = 'General',
	Withdrawal = 'Withdrawal',
	WithdrawalWithClose = 'WithdrawalWithClose',
}

export interface contactFormDetails {
	subject?: string;
	message?: string;
}

export const contactFormValidation: {
	[key in keyof Partial<contactFormDetails>]: validationTypes[];
} = {
	subject: [validationTypes.requierd],
	message: [validationTypes.requierd],
};

export const ContactsTableColumns: {
	[key: string]: DataType;
} = {
	fullName: 'custom',
	role: 'string',
	permission: 'string',
	status: 'string',
};

export const ContactsTableDefaultSort: keyof Contact = 'fullName';

export enum IdentificationType {
	ID = 'ID',
	Passport = 'Passport',
}

export enum Gender {
	Male = 'Male',
	Female = 'Female',
}

export enum LegalStatus {
	Legal = 'Legal',
	NotLegal = 'NotLegal',
}

export enum ContactStatus {
	Approved = 'Approved',
	Pending = 'Pending',
	Rejected = 'Rejected',
}
